import { useEffect, useState } from "react"
import { useCustomQuery } from "./useCustomQuery"

const useSuppliers = () => {
  const [suppliers, setSuppliers] = useState([])
  const {
    data: supplierResponse,
    isLoading,
    isError,
    isFetching,
  } = useCustomQuery(["supplier-all"], "supplier/all")

  useEffect(() => {
    if (supplierResponse?.data) {
      setSuppliers(supplierResponse.data)
    }
  }, [supplierResponse])
  return {
    suppliers,
    isLoading,
    isError,
    isFetching,
    setSuppliers,
  }
}

export default useSuppliers
